import * as FareSelectorActions from '../actions/fare-selectors';
import * as FaresSelectors from '../selectors/fares';
import * as TicketSelectors from '../selectors/fare-selectors';

import { FaresActions } from '../actions';
import { ITicketsAndFareState } from '../reducers';
import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TicketsAndFaresStoreFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  selectorsLoaded$ = this.store.select(
    TicketSelectors.selectFareSelectorsLoadState
  );
  allCustomerTypes$ = this.store.select(
    TicketSelectors.selectCustomerTypesForSelectionPage
  );
  allZones$ = this.store.select(TicketSelectors.selectZonesForSelectionPage);
  allTravelTimes$ = this.store.select(
    TicketSelectors.selectTravelTimesForSelectionPage
  );
  allTravelMethods$ = this.store.select(
    TicketSelectors.selectTravelMethodsForSelectionPage
  );

  selectedValues$ = this.store.select(TicketSelectors.selectSelectedValues);
  fareSelectorRequest$ = this.store.select(
    TicketSelectors.selectFareSelectorRequest
  );

  inputErrors$ = this.store.select(TicketSelectors.selectErrors);

  customerTypeError$ = this.store.select(
    TicketSelectors.selectCustomerTypeError
  );
  zoneError$ = this.store.select(TicketSelectors.selectZoneError);
  travelMethodError$ = this.store.select(
    TicketSelectors.selectTravelMethodError
  );
  travelTimeError$ = this.store.select(TicketSelectors.selectTravelTimeError);

  isFareSelectorsLoading$ = this.store.select(
    TicketSelectors.selectFareSelectorsLoading
  );

  selectionsValid$ = this.store.select(TicketSelectors.selectSelectionsValid);
  searchFilterDescription$ = this.store
    .select(TicketSelectors.selectFilterDesciption)
    .pipe(map((description) => this.translateFilterDescription(description)));

  searchResults$ = this.store.select(
    FaresSelectors.selectSearchFaresMatchingSelections
  );

  flexiFaresLoaded$ = this.store.select(
    FaresSelectors.selectFlexiFaresLoadState
  );
  flexiFaresSummary$ = this.store.select(
    FaresSelectors.selectAvailableFlexiSummary
  );

  paygFaresLoaded$ = this.store.select(FaresSelectors.selectPaygFaresLoadState);
  paygFaresSummary$ = this.store.select(
    FaresSelectors.selectAvailablePaygSummary
  );

  isPaygFaresLoading$ = this.store.select(
    FaresSelectors.selectPaygFaresLoading
  );

  isFlexiFaresLoading$ = this.store.select(
    FaresSelectors.selectFlexiFaresLoading
  );

  isSearchFaresLoading$ = this.store.select(
    FaresSelectors.selectSearchFaresLoading
  );

  allFares$ = this.store.select(FaresSelectors.selectAllFares);

  constructor(
    @Inject(I18NEXT_SERVICE) private i18n: ITranslationService,
    private readonly store: Store<ITicketsAndFareState>
  ) {}

  loadTicketSelectors() {
    this.store.dispatch(FareSelectorActions.loadTicketSelectors());
  }

  loadFlexiFares() {
    this.store.dispatch(FaresActions.loadFlexiFares());
  }

  loadPaygFares() {
    this.store.dispatch(FaresActions.loadPaygFares());
  }

  loadSearchFares() {
    this.store.dispatch(FaresActions.searchFares());
  }

  setCustomerType(customerType: string) {
    this.store.dispatch(FareSelectorActions.setCustomerType({ customerType }));
  }

  setCustomerTypeTouched() {
    this.store.dispatch(FareSelectorActions.setCustomerTypeTouched());
  }

  setZone(zone: string) {
    this.store.dispatch(FareSelectorActions.setZone({ zone }));
  }

  setZoneTouched() {
    this.store.dispatch(FareSelectorActions.setZoneTouched());
  }

  setTravelMethod(travelMethod: string) {
    this.store.dispatch(FareSelectorActions.setTravelMethod({ travelMethod }));
  }

  setTravelMethodTouched() {
    this.store.dispatch(FareSelectorActions.setTravelMethodTouched());
  }

  setTravelTime(travelTime: string) {
    this.store.dispatch(FareSelectorActions.setTravelTime({ travelTime }));
  }

  setTravelTimeTouched() {
    this.store.dispatch(FareSelectorActions.setTravelTimeTouched());
  }

  loadFareByAlias(ticketAlias: string) {
    this.store.dispatch(FaresActions.loadFareByAlias({ ticketAlias }));
  }

  translateFilterDescription(description: string) {
    return description
      .split(',')
      .map((filterPart) => {
        return (
          this.i18n.t(`${filterPart.trim()}`, {
            ns: 'translation',
          }) || ''
        );
      })
      .join(', ');
  }
}
